import { render, staticRenderFns } from "./PartnerDetailSettingsOpeningHoursCard.vue?vue&type=template&id=40eeca32&"
import script from "./PartnerDetailSettingsOpeningHoursCard.vue?vue&type=script&lang=ts&"
export * from "./PartnerDetailSettingsOpeningHoursCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
